import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import chevronRightBlack from '../../../../images/black-chevron-large-right.svg';
import chevronRightDisabled from '../../../../images/disabled-chevron-large-right.svg';
import chevronLeftBlack from '../../../../images/black-chevron-large-left.svg';
import chevronLeftDisabled from '../../../../images/disabled-chevron-large-left.svg';

export const StyledContainer = styled(Container)`
  position: relative;
  overflow: hidden;
`;

export const Heading = styled.div`
  margin-bottom: 48px;

  > h1,
  > h2,
  > h3 {
    font-size: 1.5rem;
    line-height: 130%;
    margin-bottom: 20px;
  }

  &.center-aligned {
    text-align: center;
  }

  > p {
    text-align: center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    > h1,
    > h2,
    > h3 {
      font-size: 2.5rem;
      line-height: 130%;
    }
  }
`;

export const Carousel = styled.div`
  position: relative;
  margin: 0 auto 2rem;
`;

export const CarouselControls = styled.div`
  display: block;
  margin: 1rem auto;
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;

  ul {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      position: absolute;
    }
    li:first-child {
      left: 0;
    }
    li:last-child {
      right: 0;
    }

    li:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const CarouselBtn = styled.button`
  width: 50px;
  height: 50px;
  &.previous-carousel {
    background-image: url(${chevronLeftBlack});
    &:disabled {
      background-image: url(${chevronLeftDisabled});
    }
  }
  &.next-carousel {
    background-image: url(${chevronRightBlack});
    &:disabled {
      background-image: url(${chevronRightDisabled});
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2,
  h3 {
    color: ${themeGet('colors.velvet')};
    margin: 0 0 30px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 50px;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    h2,
    h3 {
      margin: 0 30px 0 0;
    }
  }
`;

export const StepContainers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 20px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-top: 0px;
  }
`;

export const StepNumber = styled.div`
  background-color: ${({ theme }) => theme.colors.velvet};
  ${StyledContainer}.product-step-desktop-red &,
  ${StepContainers}.pc-red & {
    background-color: ${({ theme }) => theme.colors['pc-red']};
  }
  border-radius: 100%;
  height: 50px;
  width: 50px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.2;
  &.active {
    opacity: 1;
  }

  p {
    font-variant: tabular-nums;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    line-height: 1;
    font-size: 24px;
  }
`;
